import classNames from "classnames";
import { MDXRemote } from "next-mdx-remote";
import React from "react";

import { parseDate } from "lib/parseDate";

import styles from "./ChangelogEntry.module.css";
import Pill from "./Pill";

import type { MDXRemoteSerializeResult } from "next-mdx-remote";

export type PropTypes = {
  title: string;
  body: string;
  version: string;
  date: string;
  slug: string;
  mdxSource: MDXRemoteSerializeResult | null;
};

const ChangelogEntry: React.FC<PropTypes> = ({ mdxSource, version, date, slug }) => {
  return (
    <article className={styles.changelogEntry}>
      <span className={styles.changelogAnchor} id={version} />
      <div className={styles.changelogMeta}>
        <Pill color="red" className={styles.version} href={`/changelog/${slug}`}>
          v{version}
        </Pill>
        <span className={styles.changelogDate}>
          {new Intl.DateTimeFormat("en-US", { dateStyle: "long" }).format(parseDate(date))}
        </span>
      </div>

      <div className={classNames(styles.changelogBody, "markdown")}>
        {mdxSource ? <MDXRemote {...mdxSource} /> : null}
      </div>
    </article>
  );
};

export default ChangelogEntry;
